export const formatDateTime = (input) => {
  // Parse the input date string
  let date = new Date(input);

  // Get day, month, year, hours, and minutes
  let day = date.getUTCDate();
  let month = date.getUTCMonth();
  let year = date.getUTCFullYear();
  let hours = date.getUTCHours();
  let minutes = date.getUTCMinutes();

  // Convert month from number to string
  const monthNames = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  function getDaySuffix(day) {
    if (day > 3 && day < 21) return "th";
    switch (day % 10) {
      case 1:
        return "st";
      case 2:
        return "nd";
      case 3:
        return "rd";
      default:
        return "th";
    }
  }

  hours = hours.toString().padStart(2, "0");
  minutes = minutes.toString().padStart(2, "0");

  let formattedDate = `${hours}:${minutes}, ${day}${getDaySuffix(day)} ${
    monthNames[month]
  } ${year}`;

  return formattedDate;
};
